import React, { useState, useEffect } from 'react';
import ManagementHeaderNav from '../../components/HeadersNav/ManagementHeaderNav';
import { Box, Grid, Paper, Typography, CircularProgress, TextField, MenuItem, Checkbox, IconButton, InputAdornment , Pagination  } from '@mui/material';
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import { setOvertimeListsDDL } from '../../store/ddlReducer';
import { useDispatch } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from '@mui/x-data-grid';
import { toast } from 'react-toastify';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import moment from 'moment';

const Lists = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState([]);
  const [activeData, setActiveData] = useState([]);
  const [excludeInactive, setExcludeInactive] = useState(false);
  const dispatch = useDispatch();
  const [menu, setMenu] = useState([]);
  const [filter, setFilter] = useState('ALL');
  const [searchItem, setSearchItem] = useState('');
  const [sort, setSort] = useState('First_Name')
  const [sortType, setSortType] = useState('asc')
	const [page, setPage] = useState(1);
	const [key, setKey]=useState(1)
  const pageSize = 100;
	const [allowedVars , setAllowedVars] = useState({});
	const [showListView , setShowListView] = useState('overtime-list');
	const [orderListData , setOrderListData] = useState([]);
	const [page2, setPage2] = useState(1);
  const pageSize2 = 100;
	const [activeTab, setActiveTab] = useState('');
	const [tabKeys, setTabKeys] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [allRows, setAllRows] = useState([]);

	let getAllowedVars = () => {
    ApiService.get('/v3Variables')
      .then((res) => {
        setAllowedVars(res?.data?.data)
      }).catch(({ error }) => {
        console.log('error', error)
      });
  }

	useEffect(()=>{
		getAllowedVars()
	}, [])

  const loadData = (loading = true) => {
    if (loading == true) {
      setLoading(true);
    }
    ApiService.get(`/getLists?filter=${filter}&sort=${sort}&type=${sortType}`)
      .then(({ data }) => {
        const formattedRows = data?.data?.map((row, index) => ({
          ...row,
          id: row.Emp_Code || index,
        }));

        setAllRows(formattedRows)
        setRows(formattedRows);
				setKey(val=>val+1)
				
				const dynamicColumns = data?.lists?.map(item => ({
					style: { fontSize: 12 },
					field: item.Overtime_List,
					headerName: item.Overtime_List_Description,
					width: 170,
					sortable: true,

					valueGetter: (params) => {
						const overtimeListItem = params.row.overtime_lists?.find(
							listItem => listItem.Overtime_List === item.Overtime_List
						);
						if (!overtimeListItem) return null;

						const hours = parseInt(overtimeListItem.Hours?.split('.')[0] || " ");

						return hours;
					},

					renderCell: (params) => {
						const overtimeListItem = params.row.overtime_lists?.find(
							(listItem) => listItem.Overtime_List === item.Overtime_List
						);
						if (!overtimeListItem) return '';

						const hours = overtimeListItem.Hours?.split('.')[0] || '';
						const hoursNew = overtimeListItem.Hours_New?.split('.')[0] || '';

						if (overtimeListItem.Overtime_List === 'OVERTIME' && (allowedVars?.V3_GARCIA_RULE_START_DATE || allowedVars?.V3_GARCIA_RULE_PERIOD)) {
							return (
								<div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: 1.4 }}>
									<>
										<div>Original Hours : {hours}</div>
										<div>New Hours : {hoursNew || 0}</div>
									</>
								</div>
							);
						}

						if (overtimeListItem.Overtime_List === 'ACTINGCPT' && allowedVars?.V3_ACTING_LIST_SEPARATION_RULE) {
							return (
								hours > 0 &&
									<div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: 1.4 }}>
										<div>{hours}</div>
									</div>
							);
						}

						return hours;
					},
				}));

        const staticColumn = {
          style: { fontSize: 12 },
					field: 'fullName',
					headerName: 'Name',
          width: 180,
          sortable: true,
					valueGetter: (params) => params.row.First_name || '',
          renderCell: (params) => (
            `${params.row.EA_Rank} ${params.row.First_name} ${params.row.Last_name}`
          ),
        };

        const staticColumn2 = {
          style: { fontSize: 12 },
          field: 'EHd_Seniority',
          headerName: 'Seniority',
          width: 80,
          sortable: true,
          renderCell: (params) => (
            `${params.row.EHd_Seniority}`
          ),
        };

        const staticColumn3 = {
          style: { fontSize: 12 },
					field: 'badge',
          headerName: 'Badge#',
          width: 80,
          sortable: true,
          renderCell: (params) => (
            params.row.badge ? `${params.row.badge}` : 0
          )
        };

        const staticColumn4 = {
          style: { fontSize: 12 },
					field: 'passes',
          headerName: 'Passes',
          width: 80,
          sortable: true,
          renderCell: (params) => (
            params.row.passes ? `${params.row.passes}` : 0
          )
        };

        setColumns([staticColumn, ...dynamicColumns, staticColumn2, staticColumn3, staticColumn4]);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const loadDDL = () => {
    ApiService.get("/getOvertimeListsDDL").then(({ data }) => {
      dispatch(setOvertimeListsDDL(data));
      setMenu(data);
    });
  };
  const menuArray = Object.entries(menu);

  const sortColumn = (val) => {
    setSort(val)
    setSortType((e) => {
      if (e == 'asc') {
        return 'desc'
      }
      else return 'asc'
    })
  }

  const excludeInactiveMembers = (val) => {
    setExcludeInactive(val)
    const filteredRows = rows.filter(row => (val ? row.EA_Status === "A" : true))
    setRows(filteredRows)
  }

  const searchMembers = (search) => {
    setSearchItem(search);

    if (search.trim() === '') {
      setRows(allRows);
    } else {
      const filteredRows = allRows.filter(row => {
        const fullName = `${row.First_name} ${row.Last_name}`.toLowerCase();
        return fullName.includes(search.toLowerCase());
      });
      setRows(filteredRows);
    }
  };

  useEffect(() => {
    loadDDL();
  }, []);

  useEffect(() => {
    loadData(false)
  }, [filter, sort, sortType , allowedVars])

  useEffect(() => {
    if (rows && rows.length > 0) {
      const status = rows.map(row => row.EA_Status);
      setActiveData(status);
    }
  }, [rows]);

  const totalPages = Math.ceil(rows.length / pageSize);
  const paginatedRows = rows.slice((page - 1) * pageSize, page * pageSize);

	let columns2 = [
    {
      field: 'ID', headerName: 'Order', flex: 1, minWidth: 100
    },
    {
      field: 'name', headerName: 'Employee Name', flex: 1, minWidth: 200,
      valueGetter: (params) => {
        return `${params?.row?.Emp_Detail?.Rank + ' ' + params?.row?.Emp_Detail?.First_Name + ' ' + params?.row?.Emp_Detail?.Last_Name || ''}`;
      }
    },
		{
			field: 'Last_Accepted_At',
			headerName: 'Last Accepted at',
			flex: 1,
			minWidth: 200,
			valueGetter: (params) => {
				const value = params?.row?.Last_Accepted_At;
				return value
					? moment(value).format('MM/DD/YYYY , HH:mm:ss')
					: 'Not accepted yet';
			}
		}
  ];

 	const orderList = () => {
		setLoading(true)
		ApiService.get('/current-overtime-call-order')
			.then((res) => {
				const responseData = res?.data?.employee_order;
        if (responseData && typeof responseData === 'object') {
          const convertedArray = Object.keys(responseData).map((key) => ({
            type: key,
            data: responseData[key],
          }));

          setApiData(convertedArray); 
          setTabKeys(convertedArray.map((item) => item.type)); 

          const defaultTab = convertedArray[0]; 

          setActiveTab(defaultTab.type);
					setOrderListData(
						defaultTab.data.map((item, index) => ({
							...item,
							id: item.id || `${defaultTab.type}-${index}`,
						}))
					);
        }
				setLoading(false)
			})
			.catch(({ error }) => {
				console.log('error', error);
				setLoading(false)
			});
	};

	const totalPages2 = Math.ceil(orderListData.length / pageSize2);
  const paginatedRows2 = orderListData.slice((page2 - 1) * pageSize2, page2 * pageSize2);


  return (
    <>
      <ManagementHeaderNav />
      <Paper className="p-3" style={{ marginTop: "1rem" }}>
        <div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Overtime Lists</Typography>
            </Grid>
          </Grid>
        </div>
        <Box>
          <Row>
            <Col md={3}>
              <Grid item xs={3}>
                <TextField
                  select
                  size="small"
                  placeholder="All"
                  className="mt-3 w-100"
                  color="secondary"
                  label="All"
                  onChange={(e) => setFilter(e.target.value)}
                  variant="outlined"
                  InputProps={{
                    sx: {
                      height: '48px',
                      fontSize: '14px'
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      marginTop: '4px',
                      fontSize: "14px"
                    },
                  }}
                >
                  {menuArray.map(([key, value]) => (
                    <MenuItem value={key} key={key}>
                      {value}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Col>
            <Col md={3}>
              <Grid>
                <TextField
                  variant="outlined"
                  placeholder="Search by Name"
                  value={searchItem}
                  className="mt-3 w-100"
                  onChange={(e) => searchMembers(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: {
                      height: '48px',
                      fontSize: '14px'
                    },
                  }}
                />
              </Grid>
            </Col>
            <Col md={3}>
              <Grid>
                <div className="my-2" style={{ display: 'flex', alignItems: 'center' }}>
                  <Checkbox
                    checked={excludeInactive}
                    onChange={(e) => excludeInactiveMembers(e.target.checked)}
                  />
                  <p style={{ marginTop: '18px' }}>Exclude Inactive Members</p>
                </div>
              </Grid>
            </Col>
						{allowedVars?.V3_SEQUENTIAL_OFFERS == "true" &&
							<Col md={3}>
								<Grid>
										{showListView == 'overtime-list' ? 
											<ButtonTheme
												variant="filled" color='primary' className='px-3 mt-4' onClick = {() => {
													setShowListView('order-list')
													orderList()
												}}>
													Show Sequential List
											</ButtonTheme> 
											: 
											<ButtonTheme
												variant="filled" color='primary' className='px-3 mt-4' onClick = {() => setShowListView('overtime-list')}>
													Hide Sequential List
											</ButtonTheme>
										}
								</Grid>
							</Col>
						}
          </Row>

					{showListView == 'overtime-list' &&
						<Grid>
							{loading || !allowedVars ? (
								<Box className="w-100 h-100 d-flex justify-content-center align-items-center" style={{ minHeight: '520px' }}>
									<CircularProgress />
								</Box>
							) : (
								<>
										{!loading && rows.length > 0 &&
										<DataGrid
											rows={paginatedRows}
											columns={columns}
											sortingMode="client"
											checkboxSelection={false}
											filter={filter}
											hideFooter={true}
											sx={{
												"& .MuiDataGrid-columnHeaderTitleContainer": {
													display: "flex !important",
												},
												"& .MuiTablePagination-selectLabel": {
													marginBottom: "0 !important"
												},
												"& .MuiTablePagination-displayedRows": {
													marginBottom: "0 !important"
												},
												"& .MuiDataGrid-columnHeader": {
													minWidth: "100px",
												},
											}}
										/>
									}
									<Pagination
										count={totalPages}
										page={page}
										onChange={(event, value) => setPage(value)}
										color="primary"
										className="mt-4"
										style={{ display: "flex", justifyContent: "end" }}
									/>
								</>
							)}
							{!loading && rows.length == 0 &&
								<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 520 }}>
									<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
									<span className='mt-4' style={{ color: '#555555' }}>
										No Member Found
									</span>
								</div>
							}
						</Grid>
					}

					{showListView == 'order-list' &&
						<Grid>
							{loading ? (
								<Box className="w-100 h-100 d-flex justify-content-center align-items-center" style={{ minHeight: '520px' }}>
									<CircularProgress />
								</Box>
							) : (
								<>
										<Row className='mt-2 mb-3'>
											<Col md={9} sm={10} xs={10} style={{ display: 'flex', alignItems: 'center' }}>
												{tabKeys.map((key, index) => (
													<div
														key={index}
														style={{  cursor: 'pointer' , padding:'8px 40px' }}
														className={activeTab === key ? 'tab-active mx-2' : 'tab-white mx-2'}
														onClick={() => {
															setActiveTab(key);
															const selected = apiData.find((item) => item.type === key);

															const rowsWithId = (selected?.data || []).map((item, idx) => ({
																...item,
																id: item.id || `${key}-${idx}`,
															}));

															setOrderListData(rowsWithId);
														}}
													>
														{key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()}
													</div>
												))}
											</Col>
										</Row>

										{!loading && orderListData.length > 0 &&
										<DataGrid
											rows={paginatedRows2}
											columns={columns2}
											sortingMode="client"
											checkboxSelection={false}
											filter={filter}
											hideFooter={true}
											sx={{
												"& .MuiDataGrid-columnHeaderTitleContainer": {
													display: "flex !important",
												},
												"& .MuiTablePagination-selectLabel": {
													marginBottom: "0 !important"
												},
												"& .MuiTablePagination-displayedRows": {
													marginBottom: "0 !important"
												},
												"& .MuiDataGrid-columnHeader": {
													minWidth: "100px",
												},
											}}
										/>
									}
									<Pagination
										count={totalPages2}
										page={page2}
										onChange={(event, value) => setPage2(value)}
										color="primary"
										className="mt-4"
										style={{ display: "flex", justifyContent: "end" }}
									/>
								</>
							)}
							{!loading && orderListData.length == 0 &&
								<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 520 }}>
									<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
									<span className='mt-4' style={{ color: '#555555' }}>
										No Member Found
									</span>
								</div>
							}
						</Grid>
					}
        </Box>
      </Paper>
    </>
  );
};

export default Lists;
